"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var main_1 = require("../../../main");
function default_1(props) {
    var firstName = props.firstName, lastName = props.lastName, imageUrl = props.imageUrl;
    var style = {};
    var userIcon = React.createElement("div", null);
    var className = 'profile-icon';
    var initials = '';
    if (imageUrl) {
        style.backgroundImage = "url(" + imageUrl + ")";
    }
    else if (firstName || lastName) {
        initials += firstName ? firstName[0].toUpperCase() : '';
        initials += lastName ? lastName[0].toUpperCase() : '';
    }
    else {
        className += ' no-border';
        userIcon = React.createElement(main_1.Icon, { root: "common", name: "user" });
    }
    return (React.createElement("div", { className: className, style: style }, initials || userIcon));
}
exports.default = default_1;
